import React, { FunctionComponent } from 'react';
import { Box, Checkbox } from '@material-ui/core';
import Image from 'material-ui-image';
import Typography from '@material-ui/core/Typography';
import itemDetailsStyles, { imageStyle } from './itemDetailsStyles';
import Price from '../../../../common/components/prices/price/Price';
import { PriceDisplayType } from '../../../../../../../common/enum/PriceDisplayType';
import { DealData_accessories_attributes } from '../Accessories';

export interface ItemDetailsProps {
  item: DealData_accessories;
  isChecked: boolean;
}
export interface DealData_accessories {
  __typename: 'Accessories';
  id: number;
  price: number;
  code: string;
  attributes: DealData_accessories_attributes | null;
}

const ItemDetails: FunctionComponent<ItemDetailsProps> = ({ item, isChecked }) => {
  const styles = itemDetailsStyles();

  return (
    <Box>
      <Image
        src={item.attributes.picture}
        alt={item.attributes.label}
        animationDuration={0}
        className={styles.image}
        imageStyle={imageStyle}
        style={{ paddingTop: 0, position: 'unset' }}
        color="transparent"
        data-test={'checkout:accessories:item:image'}
      />
      <Box className={styles.details}>
        <Typography variant={'subtitle1'} data-test={'checkout:accessories:item:title'} className={styles.title}>
          {item.attributes.label}
        </Typography>
        <Typography
          variant={'body1'}
          data-test={'checkout:accessories:item:description'}
          className={styles.description}
        >
          {item.attributes.description}
        </Typography>
        <Box className={styles.container}>
          {/* TODO: Refactor price currency and checkbox isChecked flag*/}
          <Price
            price={item.price}
            priceDisplayType={PriceDisplayType.PRIMARY}
            currency={'USD'}
            className={styles.price}
            variant="h5"
          />
          <Checkbox
            checked={isChecked}
            size={'medium'}
            color={'primary'}
            data-test={`option:type:checkbox`}
            data-selected={`${isChecked}`}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ItemDetails;
